/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-05-13 10:26:22
 * @LastEditTime : 2025-10-24 11:26:29
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\docking.js
 */
import request from '@/utils/request'
export const businessSingleQueryPage = "/icps/shareFinancial/businessSingle/queryPage";
export const incomeCheckQueryPage = "/icps/shareFinancial/incomeCheck/queryPage";
export const incomeExportList = "/icps/shareFinancial/incomeCheck/dealExportList";
export const businessSingleExportList = "/icps//shareFinancial/businessSingle/exportList";

// 获取站点
export function queryAllStation(data) {
  return request({
    url: '/icps/system/sign/basics/station/queryAllStation',
    method: 'post',
    data
  })
}
// 获取主体
export function querymainBodyList(data) {
  return request({
    url: '/icps/shareFinancial/businessSingle/querymainBodyList',
    method: 'post',
    data
  })
}
// 进销存获取数据
export function queryBasicData(data) {
  return request({
    url: '/icps/shareFinancial/businessSingle/queryBasicData',
    method: 'post',
    data
  })
}
// 生成业务记账单
export function getBusinessSingle(data) {
  return request({
    url: '/icps/shareFinancial/businessSingle/getBusinessSingle',
    method: 'post',
    data
  })
}
// 保存业务记账单
export function saveBusinessSingle(data) {
  return request({
    url: '/icps/shareFinancial/businessSingle/saveBusinessSingle',
    method: 'post',
    data
  })
}
// 获取业务记账单明细
export function querySheetDatail(data) {
  return request({
    url: '/icps/shareFinancial/businessSingle/querySheetDatail',
    method: 'post',
    data
  })
}
// 获取业务记账单详情明细数据
export function querySheetData(data) {
  return request({
    url: '/icps/shareFinancial/businessSingle/querySheetData',
    method: 'post',
    data
  })
}
// 获取业务记账单详情明细数据-配件
export function queryAccessorySheetData(params) {
  return request({
    url: '/icps/shareFinancial/businessSingle/queryAccessorySheetData',
    method: 'get',
    params
  })
}
// 获取业务记账单详情明细数据-共享
export function queryBusinessBillData(params) {
  return request({
    url: '/icps/financial/external/queryBusinessBillData',
    method: 'get',
    params
  })
}
// 获取业务记账单详情明细数据-共享
export function queryAccessorySheetDataExternal(params) {
  return request({
    url: '/icps/financial/external/queryAccessorySheetData',
    method: 'get',
    params
  })
}
// 销售月报获取数据
export function queryBasicDataIncome(data) {
  return request({
    url: '/icps/shareFinancial/incomeCheck/queryBasicData',
    method: 'post',
    data
  })
}
// 生成销售月报记账单
export function queryData(data) {
  return request({
    url: '/icps/shareFinancial/incomeCheck/queryData',
    method: 'post',
    data
  })
}
// 保存销售月报记账单
export function saveincomeCheckSheet(data) {
  return request({
    url: '/icps/shareFinancial/incomeCheck/saveincomeCheckSheet',
    method: 'post',
    data
  })
}
// 获取业务记账单明细
export function queryDetail(data) {
  return request({
    url: '/icps/shareFinancial/incomeCheck/queryDetail',
    method: 'post',
    data
  })
}
// 获取收入报账单明细对应基础数据
export function queryDetailBasicData(data) {
  return request({
    url: '/icps/shareFinancial/incomeCheck/queryDetailBasicData',
    method: 'post',
    data
  })
}
// 12.共享连接-获取收入报账单明细数据
export function queryIncomeCheckDetailData(params) {
  return request({
    url: '/icps/financial/external/queryIncomeCheckDetailData',
    method: 'get',
    params
  })
}
// 配件材料表获取数据
export function queryFrAccessoryData(params) {
  return request({
    url: '/icps/shareFinancial/businessSingle/queryFrAccessoryData',
    method: 'get',
    params
  })
}
// 配件材料表生成业务记账单
export function generateBusinessAccessory(data) {
  return request({
    url: '/icps/shareFinancial/businessSingle/generateBusinessAccessory',
    method: 'post',
    data
  })
}
// 配件材料表保存业务记账单
export function saveBusinessAccessory(data) {
  return request({
    url: '/icps/shareFinancial/businessSingle/saveBusinessAccessory',
    method: 'post',
    data
  })
}
// 供应商台账获取数据
export function querySupplierAmountShare(data) {
  return request({
    url: '/icps/shareFinancial/supplierAmountShare/querySupplierAmountShare',
    method: 'post',
    data
  })
}
// 供应商台账保存数据
export function saveOrUpdate(data) {
  return request({
    url: '/icps/shareFinancial/supplierAmountShare/saveOrUpdate',
    method: 'post',
    data
  })
}
// 获取供应商台账用于生成图片
export function querySupplier(data) {
  return request({
    url: '/icps/shareFinancial/businessSingle/querySupplier',
    method: 'post',
    data
  })
}
// 原物料结算推送共享获取数据
export function materialQueryDetail(data) {
  return request({
    url: '/icps/shareFinancial/rawShare/queryDetail',
    method: 'post',
    data
  })
}
// 原物料结算推送共享获取供应商
export function queryCollaborativeUnitList(data) {
  return request({
    url: '/icps/shareFinancial/rawShare/queryCollaborativeUnitList',
    method: 'post',
    data
  })
}
// 原物料结算推送共享保存
export function pushShare(data) {
  return request({
    url: '/icps/shareFinancial/rawShare/pushShare',
    method: 'post',
    data
  })
}
// 原物料结算推送共享链接数据
export function queryProcurementDetailData(params) {
  return request({
    url: '/icps/financial/external/queryProcurementDetailData',
    method: 'get',
    params
  })
}